<template>
    <div class="page-loading" v-if="isLoading">
        <font-awesome-icon :icon="['fad', 'spinner-third']" spin />
    </div>

    <div class="container-fluid">
        <header class="main-header main-header-container">
            <h1 class="main-title" v-if="id">Hyperlink wijzigen</h1>
            <h1 class="main-title" v-else> Hyperlink toevoegen</h1>
        </header>

        <form @submit.prevent="formSubmit()">
            <div class="row">
                <div class="col">
                    <div class="card">
                        <div class="card-body">
                            <div class="mb-3">
                                <label for="name" class="form-label">Naam</label>
                                <input type="text" maxlength="35" id="name" v-model="Hyperlink.name" class="form-control" required />
                                <small id="hyperlinkNameHelp" class="form-text text-muted">
                                    De afkorting mag maximaal 35 tekens lang zijn.
                                </small>
                            </div>
                            <div class="mb-3">
                                <label for="url" class="form-label">Link</label>
                                <input type="text" id="url" v-model="Hyperlink.url" @input="validateUrl" class="form-control"
                                    :class="{ 'is-invalid': urlError }" required />
                                <div v-if="urlError" class="invalid-feedback d-block">
                                    {{ urlError }}
                                </div>
                            </div>
                            <div class="mb-3">
                                <label for="description" class="form-label">Beschrijving</label>
                                <input type="text" id="description" v-model="Hyperlink.description" class="form-control" required />
                            </div>
                            <div class="mb-3 form-check">
                                <input type="checkbox" id="visibleInMenu" v-model="Hyperlink.visibleInMenu"
                                    class="form-check-input secondary-checkbox" />
                                <label for="visibleInMenu" class="form-check-label">Toon in menu</label>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="actions">
                <button type="button" @click="cancel()" class="btn btn-gray">Annuleren</button>
                <button type="submit" class="btn btn-primary-dark ms-3">Opslaan</button>
            </div>
        </form>
    </div>
</template>


<script>
export default {
    name: 'HyperlinkDetail',
    data() {
        return {
            isLoading: false,
            urlError: '',
            Hyperlink: {
                name: '',
                url: '',
                description: '',
                visibleInMenu: false
            }
        }
    },
    computed: {
        id() {
            return this.$route.params.id;
        },
        isAlterMode() {
            return this.$route.params.id !== undefined;
        }
    },

    async created() {
        await this.loadHyperlink();
    },
    watch: {
        async id() {
            await this.loadHyperlink();
        }
    },
    methods: {
        isValidHttpsUrl(value) {
            try {
                const url = new URL(value);
                return url.protocol === 'https:' || url.protocol === 'http:';
            } catch {
                return false;
            }
        },
        validateUrl() {
            if (!this.Hyperlink.url) {
                this.urlError = '';
                return false;
            }

            if (!this.isValidHttpsUrl(this.Hyperlink.url)) {
                this.urlError = 'Voer een geldige URL in die begint met http:// of https://';
                return false;
            }

            this.urlError = '';
            return true;
        },
        cancel() {
            this.$router.push('/hyperlinks');
        },
        async loadHyperlink() {
            if (!this.id) {
                return;
            }

            this.isLoading = true;
            await this.$axiosInstance.get(`${process.env.VUE_APP_API}/hyperlink/${this.id}`)
                .then(success => this.Hyperlink = success.data)
                .catch(error => console.error(error))
                .finally(() => this.isLoading = false);
        },
        async formSubmit() {
            if (!this.validateUrl()) {
                return;
            }

            if (this.isAlterMode) {
                await this.updateHyperlink();
            }
            else {
                await this.createHyperlink();
            }
        },
        async createHyperlink() {
            await this.$axiosInstance.post(`${process.env.VUE_APP_API}/hyperlink`, this.Hyperlink)
                .then(success => {
                    this.$toast.open({
                        message: 'Hyperlink succesvol toegevoegd.',
                        type: 'success',
                        position: 'top-right',
                        duration: 5000
                    });
                    const hyperlinkId = success?.data?.id;

                    if (hyperlinkId) {
                        this.$router.push(`/hyperlinks/${hyperlinkId}`);
                        return;
                    }

                    this.$router.push('/hyperlinks');
                })
                .catch(error => {
                    this.$toast.open({
                        message: 'Hyperlink kon niet toegevoegd worden. Probeer het a.u.b. opnieuw.',
                        type: 'error',
                        position: 'top-right',
                        duration: 5000
                    });
                    console.error(error);
                });
        },
        async updateHyperlink() {
            await this.$axiosInstance.put(`${process.env.VUE_APP_API}/hyperlink/${this.id}`, this.Hyperlink)
                .then(() => {
                    this.$toast.open({
                        message: 'Hyperlink succesvol bijgewerkt.',
                        type: 'success',
                        position: 'top-right',
                        duration: 5000
                    });
                    this.$router.push('/hyperlinks');
                })
                .catch(error => {
                    this.$toast.open({
                        message: 'Hyperlink kon niet bijgewerkt worden. Probeer het a.u.b. opnieuw.',
                        type: 'error',
                        position: 'top-right',
                        duration: 5000
                    });
                    console.error(error);
                });
        }
    }
}

</script>

<style lang="scss" scoped>
.actions {
  margin-top: $spacer * 1.5;
  display: flex;
  align-items: center;
  justify-content: flex-end;

  .btn {
    min-width: 7.5rem;
  }
}

.row {
  margin-bottom: $spacer;
}
</style>
